"use client";

import React from "react";
import { Loader, CheckCircle, Send } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="39086" className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="rounded-full bg-[var(--color-accent)] p-3">
          <CheckCircle className="size-12 text-[var(--color-primary)]" />
        </div>
        <h3 className="text-2xl font-bold text-foreground font-sans">Inscrição Enviada!</h3>
        <p className="text-muted-foreground max-w-xs mx-auto font-sans">
          {successMessage || "Obrigado por se juntar à nossa rede. A nossa equipa analisará o seu perfil e entrará em contacto em breve."}
        </p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="name" rules={{
        required: "O nome é obrigatório"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/80 font-sans">Nome Completo</FormLabel>
              <FormControl>
                <Input placeholder="Seu nome" {...field} className="bg-[#1a1a1c] text-white border-transparent rounded-full px-6 h-12 focus-visible:ring-[var(--color-primary)] focus-visible:border-[var(--color-primary)] transition-all duration-300 font-sans text-base" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "O telefone é obrigatório",
        pattern: {
          value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
          message: "Número de telefone inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/80 font-sans">Telefone</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+351 900 000 000" {...field} className="bg-[#1a1a1c] text-white border-transparent rounded-full px-6 h-12 focus-visible:ring-[var(--color-primary)] focus-visible:border-[var(--color-primary)] transition-all duration-300 font-sans text-base" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "O email é obrigatório",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email inválido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/80 font-sans">Email Profissional</FormLabel>
            <FormControl>
              <Input type="email" placeholder="seu@email.com" {...field} className="bg-[#1a1a1c] text-white border-transparent rounded-full px-6 h-12 focus-visible:ring-[var(--color-primary)] focus-visible:border-[var(--color-primary)] transition-all duration-300 font-sans text-base" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="company" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/80 font-sans">Empresa (Opcional)</FormLabel>
            <FormControl>
              <Input placeholder="Nome da sua agência" {...field} className="bg-[#1a1a1c] text-white border-transparent rounded-full px-6 h-12 focus-visible:ring-[var(--color-primary)] focus-visible:border-[var(--color-primary)] transition-all duration-300 font-sans text-base" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/80 font-sans">Detalhes da Recomendação</FormLabel>
            <FormControl>
              <textarea className="flex min-h-[100px] w-full rounded-[24px] border border-transparent bg-[#1a1a1c] text-white px-6 py-4 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-primary)]/50 focus-visible:border-[var(--color-primary)] disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-300 resize-y font-sans" placeholder="Conte-nos como pretende colaborar connosco." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive text-sm animate-in fade-in slide-in-from-top-2 font-sans">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-bold bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90 text-white rounded-full shadow-lg hover:shadow-[var(--color-primary)]/20 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            A processar...
          </> : <>
            Começar a Ganhar Hoje <Send className="ml-2 size-4" />
          </>}
      </Button>
    </Form>;
}
export default function FinalCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}